import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Loader } from "../../../../components";
import { postRequest } from "../../../../constants/api";
import { Colors } from "../../../../constants/styles";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Autocomplete,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { NumericFormat } from "react-number-format";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahJual = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noNotaJual, setNoNotaJual] = useState("");
  const [jenisJual, setJenisJual] = useState("");
  const [inputTanggalJual, setInputTanggalJual] = useState(new Date());
  const [kodePelanggan, setKodePelanggan] = useState("");
  const [tipePelanggan, setTipePelanggan] = useState("ECERAN");
  const [kodeCOA, setKodeCOA] = useState("");

  // Data Child
  const [totalTransaksi, setTotalTransaksi] = useState(0);
  const [reloadListJualChild, setReloadListJualChild] = useState(0);
  const [listJualChild, setListJualChild] = useState([
    {
      barang: "",
      jumlah1: 0,
      harga: 0,
      subtotalJualChild: 0,
    },
  ]);

  const [pelanggans, setPelanggans] = useState([]);
  const [coas, setCoas] = useState([]);
  const [barangs, setBarangs] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const jenisJualOption = ["TUNAI", "HUTANG"];
  let pelangganOptions = pelanggans.map((pelanggan) => ({
    label: `${pelanggan.kodePelanggan} - ${pelanggan.namaPelanggan}`,
    tipePelanggan: pelanggan.tipePelanggan,
  }));
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));
  let barangOptions = barangs.map((barang) => ({
    label: `${barang.kodeBarang} - ${barang.namaBarang}`,
  }));

  useEffect(() => {
    getNextKodeJual(new Date());
    getPelanggansData();
    getCoasData();
    getBarangsData();
  }, []);

  const getPelanggansData = async () => {
    const response = await postRequest(`/pelanggans`, {}, navigate, dispatch);
    setPelanggans(response.data);
  };

  const getCoasData = async () => {
    const response = await postRequest(`/COAsKasBank`, {}, navigate, dispatch);
    setCoas(response.data);
  };

  const getNextKodeJual = async (inputTanggalJual) => {
    const nextKodeJual = await postRequest(
      `/jualsNextKode`,
      { tanggalJual: inputTanggalJual },
      navigate,
      dispatch
    );
    setNoNotaJual(nextKodeJual.data);
  };

  const getBarangsData = async () => {
    setLoading(true);
    const response = await postRequest(`/barangs`, {}, navigate, dispatch);
    setBarangs(response.data);
    setLoading(false);
  };

  const getBarang = async (kodeBarang, index) => {
    if (kodeBarang.length === 0) {
      return;
    }
    let tempKodeBarang = kodeBarang.split(" -", 1)[0];

    const pickedBarang = await postRequest(
      `/barangsByKodeBarang`,
      { kodeBarang: tempKodeBarang },
      navigate,
      dispatch
    );
    if (pickedBarang.data) {
      let tempHarga = pickedBarang.data.hargaEceran;
      if (tipePelanggan === "BAKUL") {
        tempHarga = pickedBarang.data.hargaBakul;
      } else if (tipePelanggan === "BAKUL1") {
        tempHarga = pickedBarang.data.hargaBakul1;
      } else if (tipePelanggan === "BAKUL2") {
        tempHarga = pickedBarang.data.hargaBakul2;
      }

      listJualChild[index].harga = tempHarga;
      listJualChild[index].subtotalJualChild =
        listJualChild[index].jumlah1 * tempHarga;
      setReloadListJualChild(Math.floor(Math.random() * 1000));
    } else {
      listJualChild[index].harga = 0;
      listJualChild[index].subtotalJualChild = 0;
      setReloadListJualChild(Math.floor(Math.random() * 1000));
    }
  };

  const saveJual = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempCheckValidity =
      form.checkValidity() &&
      jenisJual.length !== 0 &&
      kodePelanggan.length !== 0;
    if (jenisJual === "TUNAI") {
      tempCheckValidity =
        form.checkValidity() &&
        jenisJual.length !== 0 &&
        kodePelanggan.length !== 0 &&
        kodeCOA.length !== 0;
    }

    if (tempCheckValidity) {
      setLoading(true);
      try {
        setLoading(true);
        const savedJual = await postRequest(
          `/saveJualAndSaveTransaksi`,
          {
            tanggalJual: inputTanggalJual,
            jenisJual,
            tanggalLunas: "",
            lunas: jenisJual === "HUTANG" ? 0 : 1,
            kodePelanggan: kodePelanggan.split(" -", 1)[0],
            kodeCOA,

            listJualChild,
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate(`/daftarJual/jual/${savedJual.data.id}`);
      } catch (error) {
        alert(error);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Jual</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveJual}>
        <Card>
          <Card.Header>Jual</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Nota :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noNotaJual}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={jenisJualOption}
                      renderInput={(params) => (
                        <TextField
                          error={error && jenisJual.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onInputChange={(e, value) => {
                        setJenisJual(value);

                        if (value === "TUNAI") {
                          setKodeCOA(setting.coaKasKasir);
                        } else {
                          setKodeCOA("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTanggalJual}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setInputTanggalJual(date);
                        getNextKodeJual(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Pelanggan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={pelangganOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodePelanggan.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        setKodePelanggan(value.label);
                        setTipePelanggan(value.tipePelanggan);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas{" "}
                    {jenisJual === "TUNAI" && <b style={colorRed}>*</b>} :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={coaOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCOA.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCOA(value.label.split(" ", 1)[0]);
                        } else {
                          setKodeCOA("");
                        }
                      }}
                      value={kodeCOA}
                      disabled={jenisJual !== "TUNAI" && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="success"
                onClick={() => navigate("/daftarJual/jual/tambahPelanggan")}
                sx={{ marginRight: 2 }}
              >
                {"Tambah Pelanggan"}
              </Button>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                color="info"
                sx={{
                  bgcolor: "info.light",
                  textTransform: "none",
                  marginRight: 2,
                  marginBottom: 2,
                }}
                onClick={() => {
                  listJualChild.push({
                    barang: "",
                    jumlah1: 0,
                    harga: 0,
                    subtotalJualChild: 0,
                  });
                  setReloadListJualChild(Math.floor(Math.random() * 1000));
                }}
              >
                {"+ Input Transaksi"}
              </Button>
            </Box>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Barang
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Jumlah 1
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Harga
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Subtotal
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hapus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listJualChild.map((jualChild, index) => (
                    <TableRow>
                      <TableCell>
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={barangOptions}
                          renderInput={(params) => (
                            <TextField
                              multiline
                              rows={4}
                              size="small"
                              sx={{ width: "200px" }}
                              {...params}
                            />
                          )}
                          value={jualChild.barang}
                          onChange={(e, value) => {
                            if (value) {
                              getBarang(value.label, index);
                              jualChild.barang = value.label;
                              setReloadListJualChild(
                                Math.floor(Math.random() * 1000)
                              );
                            } else {
                              jualChild.barang = "";
                              setReloadListJualChild(
                                Math.floor(Math.random() * 1000)
                              );
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={jualChild.jumlah1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            jualChild.jumlah1 = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let jualChildData of listJualChild) {
                              let tempNominal =
                                parseFloat(jualChildData.jumlah1) *
                                parseFloat(jualChildData.harga);

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            jualChild.subtotalJualChild =
                              parseFloat(jualChild.jumlah1) *
                              parseFloat(jualChild.harga);

                            setReloadListJualChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={jualChild.harga}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            jualChild.harga = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let jualChildData of listJualChild) {
                              let tempNominal =
                                parseFloat(jualChildData.jumlah1) *
                                parseFloat(jualChildData.harga);

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            jualChild.subtotalJualChild =
                              parseFloat(jualChild.jumlah1) *
                              parseFloat(jualChild.harga);

                            setReloadListJualChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={jualChild.subtotalJualChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            jualChild.subtotalJualChild = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            let tempTotalTransaksi = 0;
                            for (let jualChildData of listJualChild) {
                              let tempNominal = parseFloat(
                                jualChildData.subtotalJualChild
                              );

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            setReloadListJualChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          sx={{ textTransform: "none" }}
                          onClick={() => {
                            listJualChild.splice(index, 1);

                            let tempTotalTransaksi = 0;
                            for (let jualChildData of listJualChild) {
                              let tempNominal = parseInt(
                                jualChildData.subtotalJualChild
                              );

                              if (isNaN(tempNominal)) {
                                tempNominal = 0;
                              }

                              tempTotalTransaksi += tempNominal;
                            }
                            setTotalTransaksi(tempTotalTransaksi);

                            setReloadListJualChild(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell component="th" scope="row"></TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">Total</TableCell>
                    <TableCell>
                      <Form.Control
                        value={totalTransaksi.toLocaleString("de-DE")}
                        disabled
                        readOnly
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Card.Body>
        </Card>
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarJual")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahJual;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const colorRed = {
  color: "red",
};
